import React, { useState, useEffect } from "react";
import { Drawer, Form, Input, DatePicker, Icon, notification } from "antd";
import axios from "axios";
import moment from "moment";

const { TextArea } = Input;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerRelatorio = ({ id, visible, atualizarListagem, onClose, form }) => {
    const [registo, setRegisto] = useState({
        id: null,
        nome_aluno: "",
        data_nascimento: moment(),
        ano_serie: "",
        periodo_atendimento_aee: "",
        professor_aee: "",
        diagnostico_clinica: "",
        frequencia_sessoes: "",
        escola_regular: "",
        sala_recurso: "",
        objetivos_aee: "",
        recursos_estrategias: "",
        observacoes_desempenho: "",
        encaminhamentos_sugestoes: ""
    });
    const [dtInicio, setDtInicio] = useState(null);
    const [dtTermino, setDtTermino] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const intervaloCalendario = () => {
        axios({
            method: "get",
            url: "/api/aulas/intervalo-calendario-turma",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                this.setState({
                    dtInicio: response.data.dt_inicio,
                    dtTermino: response.data.dt_termino
                });
            })
            .catch(() => {});
    };

    const handleSubmit = e => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (!err) {
                if (id) alterarRelatorio(values);
                else adicionarRelatorio(values);
            }
        });
    };

    const carregarDetalhe = id => {
        axios({
            method: "get",
            url: "/api/atendimento/carregar-relatorio-individual",
            params: {
                id
            }
        })
            .then(response => {
                const dados = {
                    ...response.data,
                    data_nascimento: response.data.data_nascimento ? moment(response.data.data_nascimento) : null
                };
                setRegisto(dados);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao carregar o detalhe do relatório.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const adicionarRelatorio = registo => {
        setIsLoading(true);

        var relatorio = {
            disciplinaId: localStorage.getItem("codigo_curso"),
            nomeAluno: registo.nome_aluno,
            dataNascimento: registo.data_nascimento.format("YYYY-MM-DD"),
            anoSerie: registo.ano_serie,
            periodoAtendimentoAee: registo.periodo_atendimento_aee,
            professorAee: registo.professor_aee,
            diagnosticoClinica: registo.diagnostico_clinica,
            frequenciaSessoes: registo.frequencia_sessoes,
            escolaRegular: registo.escola_regular,
            salaRecurso: registo.sala_recurso,
            objetivosAee: registo.objetivos_aee,
            recursosEstrategias: registo.recursos_estrategias,
            observacoesDesempenho: registo.observacoes_desempenho,
            encaminhamentosSugestoes: registo.encaminhamentos_sugestoes
        };

        axios({
            method: "post",
            url: "/api/atendimento/adicionar-relatorio-individual",
            data: relatorio
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Relatório criado com sucesso.");
                atualizarListagem();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao criar o Relatório.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const alterarRelatorio = registo => {
        setIsLoading(true);

        var relatorio = {
            id: id,
            nomeAluno: registo.nome_aluno,
            dataNascimento: registo.data_nascimento.format("YYYY-MM-DD"),
            anoSerie: registo.ano_serie,
            periodoAtendimentoAee: registo.periodo_atendimento_aee,
            professorAee: registo.professor_aee,
            diagnosticoClinica: registo.diagnostico_clinica,
            frequenciaSessoes: registo.frequencia_sessoes,
            escolaRegular: registo.escola_regular,
            salaRecurso: registo.sala_recurso,
            objetivosAee: registo.objetivos_aee,
            recursosEstrategias: registo.recursos_estrategias,
            observacoesDesempenho: registo.observacoes_desempenho,
            encaminhamentosSugestoes: registo.encaminhamentos_sugestoes
        };

        axios({
            method: "put",
            url: "/api/atendimento/alterar-relatorio-individual",
            data: relatorio
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Relatório altarado com sucesso.");
                atualizarListagem();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data || "Ocorreu um erro ao alterar o Relatório.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    nome_aluno: aluno?.nome || "",
                    ano_serie: turma?.nome || "",
                    idade: aluno?.idade ?? null,
                    professor: turma?.professor || "",
                    escola: turma?.escola || "",
                    turno: turma?.turno || ""
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const handleClose = () => {
        onClose();
        limparCampos();
    };

    const afterVisibleChange = aberto => {
        if (!aberto && id === null) {
            limparCampos();
        }
    };

    const limparCampos = () => {
        form.resetFields();
        setRegisto({
            id: null,
            tipo: "plano_atendimento_especializado",
            data_realizacao: moment(),
            nome_aluno: "",
            idade: null,
            ano_serie: "",
            turno: "",
            escola: "",
            professor_aee: "",
            historico_escolas: "",
            necessidades_educacionais: "",
            objetivos_cognitivos: "",
            objetivos_socioemocionais: "",
            estrategias_recursos: "",
            parcerias: "",
            cronograma_atendimentos: "",
            avaliacao_monitoramento: "",
            descricao: "",
            tecnicas_utilizadas: ""
        });
    };

    const disabledDate = current => {
        return current < moment(dtInicio).startOf("day") || current > moment(dtTermino).endOf("day");
    };

    useEffect(() => {
        if (visible) {
            intervaloCalendario();

            if (id) carregarDetalhe(id);
        }

        if (visible && !id) {
            carregarDadosAlunoEnsinoEspecial();
        }
    }, [id, visible]);

    const { getFieldDecorator } = form;

    return (
        <>
            <Drawer
                title={
                    <div>
                        <div style={{ fontWeight: "bold", fontSize: 16 }}>Cadastro de Relatório Individual</div>
                        <div style={{ fontSize: 12, color: "#888" }}>Preencha os dados para cadastrar um novo relatório.</div>
                    </div>
                }
                className="drawer-adicionar-evento drawer-adicionar-curso"
                width={720}
                onClose={handleClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div className="bloco-info">
                    <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                        <div className="bloco">
                            <Form.Item label="Nome do aluno">
                                {getFieldDecorator("nome_aluno", {
                                    initialValue: registo.nome_aluno,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Data de Nascimento">
                                {getFieldDecorator("data_nascimento", {
                                    initialValue: registo.data_nascimento,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<DatePicker className="input-25" placeholder="Selecionar" format="DD-MM-YYYY" name="dt_fimAula" />)}
                            </Form.Item>
                            <Form.Item label="Ano/Série">
                                {getFieldDecorator("ano_serie", {
                                    initialValue: registo.ano_serie,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Período de atendimento no AEE">
                                {getFieldDecorator("periodo_atendimento_aee", {
                                    initialValue: registo.periodo_atendimento_aee,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Professor(a) de AEE responsável">
                                {getFieldDecorator("professor_aee", {
                                    initialValue: registo.professor_aee,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Diagnóstico/Conduta clínica (se houver)">
                                {getFieldDecorator("diagnostico_clinica", {
                                    initialValue: registo.diagnostico_clinica
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Frequência nas Sessões">
                                {getFieldDecorator("frequencia_sessoes", {
                                    initialValue: registo.frequencia_sessoes,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Escola Regular">
                                {getFieldDecorator("escola_regular", {
                                    initialValue: registo.escola_regular,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="Sala de Recurso">
                                {getFieldDecorator("sala_recurso", {
                                    initialValue: registo.sala_recurso,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<Input />)}
                            </Form.Item>
                            <Form.Item label="1. Objetivos do AEE">
                                {getFieldDecorator("objetivos_aee", {
                                    initialValue: registo.objetivos_aee,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<TextArea rows={4} style={{ height: 100 }} />)}
                            </Form.Item>
                            <Form.Item label="2. Recursos e estratégias utilizados">
                                {getFieldDecorator("recursos_estrategias", {
                                    initialValue: registo.recursos_estrategias,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<TextArea rows={4} style={{ height: 100 }} />)}
                            </Form.Item>
                            <Form.Item label="3. Observações sobre o desempenho">
                                {getFieldDecorator("observacoes_desempenho", {
                                    initialValue: registo.observacoes_desempenho,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<TextArea rows={4} style={{ height: 100 }} />)}
                            </Form.Item>
                            <Form.Item label="4. Encaminhamentos e sugestões">
                                {getFieldDecorator("encaminhamentos_sugestoes", {
                                    initialValue: registo.encaminhamentos_sugestoes,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(<TextArea rows={4} style={{ height: 100 }} />)}
                            </Form.Item>
                        </div>
                        <div className="ant-drawer-footer">
                            <button
                                className="botao-secundario"
                                type="button"
                                onClick={handleClose}
                                style={{ marginRight: 20, display: "inline-block" }}
                            >
                                Cancelar
                            </button>
                            <button className="botao-principal" disabled={isLoading}>
                                {isLoading ? <Icon type="loading" /> : null}
                                Salvar Relatório
                            </button>
                        </div>
                    </Form>
                </div>
            </Drawer>
        </>
    );
};

export default Form.create({ name: "form-drawer-relatorio" })(DrawerRelatorio);
